const saveLicenseVerificationData = (licenseVerification) => ({
  type: 'SAVE_LICENSE_VERIFICATION_DATA',
  payload: {
    licenseVerification,
  },
});

export { saveLicenseVerificationData };
